import { Axis } from './Axis.js';
import { OrientedAxisProps } from './types.js';

/**
 * @internal
 */
export function AxisTableHeader({
  scale,
  height,
  ...restAxisProps
}: Readonly<Omit<OrientedAxisProps, 'label'>>) {
  return (
    <Axis
      orientation="bottom"
      height={height}
      scale={scale}
      size="base"
      {...restAxisProps}
    />
  );
}

AxisTableHeader['displayName'] = 'AxisTableHeader';
